import { useCallback } from 'react'

export const useDownload = () => {
  const handleDownload = useCallback((blob: Blob, filename: string) => {
    try {
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    } catch (error) {
      // Error is already handled in the hook
      console.error('Download failed:', error)
    }
  }, [])
  return { handleDownload }
}
